<template>
    <div class="u-padding-narrow">
        <div class="u-margin-bottom"></div>
        <div class="layout layout--center | u-full-height">
            <div class="layout__item u-4/5-desk">
                <header-partial :domain="domain" />

                <div class="page-block">
                    <technical-management-tabs :step="5" :domain="domain" :service="firstServiceForDomain" />

                    <div v-if="customerValues.length" class="page-block__item-wrapper">
                        <div class="u-margin-bottom-narrow">
                            {{
                                trans('services.customer-information', {
                                    domain: this.domain
                                })
                            }}
                        </div>

                        <form
                            @submit.prevent="changeCustomer"
                            class="page-block__item-wrapper-customer | u-full-width "
                        >
                            <div class="page-block__item u-border-bottom-flush">
                                <div class="page-block__item-content">
                                    <div class="layout | u-flex-center">
                                        <div class="layout__item u-1/1-portable u-1/4-desk">
                                            <span class="page-block__item-content-title">
                                                {{ trans('services.customer') }}
                                            </span>
                                        </div>
                                        <!--
                                     -->
                                        <div class="layout__item u-1/1-portable u-3/4-desk">
                                            <single-select
                                                v-model="form.customer"
                                                :error="form.errors.first('customer')"
                                                :options="customerValues"
                                                :placeholder="trans('services.change-customer-placeholder')"
                                                optionLabel="name"
                                                optionValue="id"
                                                name="customer"
                                                class="u-full-width"
                                                required
                                                focus
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div class="page-block__item-nav">
                                    <button
                                        class="btn btn--blue-record"
                                        dusk="confirm-button"
                                        type="submit"
                                        :disabled="loading"
                                    >
                                        {{ trans('action.set') }}
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { HeaderPartial, serviceMixin, ServicesApi, servicesPageMixin } from 'relapp-technical-management';
import { customerMixin } from 'relapp-customers';
import { Way2Form } from 'relapp-way2forms';
import { pageLoadingStatusMixin } from 'relapp-loading';
import { apiMixin } from 'relapp-api';
import { EventBus } from 'relapp-event';

export default {
    components: {
        HeaderPartial
    },
    mixins: [serviceMixin, servicesPageMixin, customerMixin, pageLoadingStatusMixin, apiMixin],
    /**
     * Add all the properties found in the data object to Vue’s reactivity system.
     *
     * @return {object}
     */
    data() {
        return {
            serviceType: 'dns',
            form: new Way2Form({
                customer: ''
            })
        };
    },
    computed: {
        /**
         * Get the customer by domain from the services.
         *
         * @return {integer}
         */
        customerId() {
            return this.servicesByDomain[0].customer_id;
        }
    },
    /**
     * Called after the instance has been mounted.
     */
    mounted() {
        this.getServices();
        this.form.customer = this.customerId;
    },
    /**
     * Get the meta info for the page.
     *
     * @return {object}
     */
    metaInfo() {
        return {
            title: trans('page.customer.title', { domain: this.domain })
        };
    },
    methods: {
        /**
         * Send the changed customer of the service to the endpoint.
         */
        changeCustomer() {
            this.startLoading();
            this.form.errors.clear();

            ServicesApi.changeCustomer({ domain: this.domain, data: this.form.data() })
                .then(() => {
                    EventBus.$emit('notification', {
                        type: 'success',
                        message: trans('services.confirmation.customer.message')
                    });
                    this.getServices();
                })
                .catch(error => {
                    this.showValidationErrors(error, this.form);
                })
                .then(this.finishLoading);
        }
    }
};
</script>
